const getAppIcon = (assets) => {
  const appIcon = assets?.filter((asset) => {
    return asset?.type === 'icon';
  });
  if (appIcon?.length) {
    return appIcon[0].url;
  }
};

export default getAppIcon;
